module.exports = __webpack_public_path__ + "static/media/luxurybar2.cf2cab84.jpg";